import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21404 34779"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:504.045}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278267840">
        <path
          d="M10702 29279c770 0 1395-625 1395-1394 0-770-625-1394-1395-1394s-1395 624-1395 1394c0 769 625 1394 1395 1394zM10702 24031c770 0 1395-624 1395-1394 0-769-625-1395-1395-1395s-1395 625-1395 1395c1 770 625 1394 1395 1394zM10702 18783c770 0 1395-624 1395-1394s-625-1394-1395-1394-1395 624-1395 1394c0 771 625 1394 1395 1394zM10702 34527c770 0 1395-624 1395-1394s-625-1394-1395-1394-1395 624-1395 1394c1 770 625 1394 1395 1394zM1647 13536c769 0 1394-624 1394-1394s-624-1395-1394-1395-1395 624-1395 1395c0 770 625 1394 1395 1394zM6174 13536c770 0 1394-624 1394-1394s-624-1395-1394-1395-1394 624-1394 1395c0 770 624 1394 1394 1394zM6174 8289c770 0 1394-624 1394-1395 0-770-624-1394-1394-1394s-1394 624-1394 1394 624 1395 1394 1395zM10702 13536c770 0 1395-624 1395-1394s-625-1395-1395-1395-1395 624-1395 1395c1 770 625 1394 1395 1394zM10702 8289c770 0 1395-624 1395-1395 0-770-625-1394-1395-1394s-1395 624-1395 1394c1 770 625 1395 1395 1395zM10702 3040c770 0 1395-624 1395-1394s-625-1394-1395-1394-1395 624-1395 1394c1 770 625 1394 1395 1394zM15230 13536c770 0 1395-624 1395-1394s-625-1395-1395-1395c-769 0-1394 624-1394 1395 0 770 624 1394 1394 1394zM15230 8289c770 0 1395-624 1395-1395 0-770-625-1394-1395-1394-769 0-1394 624-1394 1394s624 1395 1394 1395zM19758 13536c770 0 1394-624 1394-1394s-624-1395-1394-1395-1394 624-1394 1395c0 770 624 1394 1394 1394z"
          className="fill stroke1"
          style={{
            strokeWidth: 504.045,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
